export default "__VITE_ASSET__fa38887b__"